var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"menu"},[_c('Cta',{attrs:{"data":{
      title: !_vm.user ? _vm.$labels.login : _vm.$labels.account,
      url: { name: 'EditAccount' },
    },"theme":"menu"}}),_c('Cta',{attrs:{"data":{
      title:
        _vm.cart && _vm.cart.items
          ? ((_vm.$labels.cart) + " (" + (_vm.cart.item_count) + ")")
          : _vm.$labels.cart,
      url: '/cart',
    },"theme":"menu"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }